// src/hooks/useTallerData.js
import { useState, useEffect, useMemo } from 'react';
import Talleres from '../service/Talleres';
import { useNotify } from '../providers/NotificationProvider';

export const useTallerData = (tallerId) => {
  const [taller, setTaller] = useState(null);
  const [loading, setLoading] = useState(true);
  const notify = useNotify();

  const esGratis = useMemo(() => {

    return taller?.esGratuito === true || 
           !taller?.modalidadPago || 
           taller?.modalidadPago.length === 0;
  }, [taller]);

  const loadTaller = async () => {
    try {
      setLoading(true);
      const res = await Talleres.getById(tallerId);
      setTaller(res);
    } catch (error) {
      notify.error('Error al cargar el taller');
      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (tallerId) {
      loadTaller();
    }
  }, [tallerId]);

  return { taller, loading, esGratis };
};
